import { render, staticRenderFns } from "./BattleObjective.vue?vue&type=template&id=2c8710e4&scoped=true&"
import script from "./BattleObjective.vue?vue&type=script&lang=js&"
export * from "./BattleObjective.vue?vue&type=script&lang=js&"
import style0 from "./BattleObjective.vue?vue&type=style&index=0&id=2c8710e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8710e4",
  null
  
)

export default component.exports